import { translate } from '../../../lib/translations';

interface DraftPickTradeInfoProps {
  description: string | null;
  originalUsername?: string | null;
  language: 'en' | 'fr';
}

export function DraftPickTradeInfo({
  description,
  originalUsername,
  language,
}: DraftPickTradeInfoProps) {
  if (!description) return null;

  return (
    <div className="list-group-item border-0 p-3 rounded mb-2 shadow-sm">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className="bg-warning rounded-circle d-flex align-items-center justify-content-center me-3" 
               style={{ width: '40px', height: '40px', minWidth: '40px' }}>
            <span className="fw-bold text-dark">📋</span>
          </div>
          <div>
            <h6 className="mb-1 fw-bold text-primary">{description}</h6>
            <div className="text-muted small">
              {translate('draft.pick', language)}
              {originalUsername && (
                <div className="mt-1">
                  <small>Propriétaire original: {originalUsername}</small>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="text-end">
          <span className="badge bg-warning text-dark">
            {translate('draft.pick', language)}
          </span>
        </div>
      </div>
    </div>
  );
}
